import { render } from "./ContactIcon.vue?vue&type=template&id=1569b023"
import script from "./ContactIcon.vue?vue&type=script&lang=js"
export * from "./ContactIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__